import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#3C1F6C",
    },
    secondary: {
      main: "#3B68BF", // 300 #2c67c6
    },
    custom: {
      main: "#4C8FE5",
    },

    // dashboard
    dashboardBlue: {
      main: "#5956ff",
    },
    reGreen: {
      main: "#009688",
    },
  },
  typography: {
    fontFamily: "Quicksand, sans-serif",
    button: {
      textTransform: "unset",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // base styles
          fontWeight: 600,
        },
        containedPrimary: {
          color: "#fff",
          backgroundColor: "#673AB7",
        },
        containedSecondary: {
          color: "#fff",
          backgroundColor: "#4C8FE5",
        },
        containedCustom: {
          color: "#fff",
        },
      },
    },
  },
});
